import { DocumentationValidationStatusEnum } from 'graphql-common';
import { ChipTypes } from '@lib/components/Chip/Chip';

export default function getValidationStatusOptions() {
  return [
    {
      labelKey: 'on-validation',
      value: DocumentationValidationStatusEnum.OnValidation,
      color: ChipTypes.chipOrange,
    },
    {
      labelKey: 'validated',
      value: DocumentationValidationStatusEnum.Validated,
      color: ChipTypes.chipGreen,
    },
    {
      labelKey: 'rejected',
      value: DocumentationValidationStatusEnum.Rejected,
      color: ChipTypes.chipRed,
    },
  ];
}
